var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink, Trans } from '@lucidlink/uicore';
export const WorkspaceLimitNavToBilling = ({ workspaceId, }) => {
    return (_jsx(ButtonLink, { "data-testid": "upgrade-plan", isFullWidth: true, size: "big", to: `/workspaces/${workspaceId}/settings/billing/plans`, children: _jsx(Trans, { children: "Upgrade plan" }) }));
};
_react_refresh_temp_1 = WorkspaceLimitNavToBilling;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceLimitNavToBilling");
